import React from 'react';
import styled from 'styled-components';

import { getViewPortDimensions } from '../facade/window';
import { AnalyticsConsumerProps, withAnalytics } from '../hoc/withAnalytics';

import EmptyState from './EmptyState';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import { onDesktop, onMobile } from './mobile/responsive';
import Products from './Products';
import YourWorkTabs from './YourWorkTabs';

const PageTopMargin = styled.div`
  // Give bit more padding because it's nice
  ${onDesktop(`
    padding-top: 40px;
  `)}

  // Slightly larger padding because mobile has top horizontal nav
  ${onMobile(`
    padding-top: 60px;
  `)}
`;

type Props = {
  atlOrigin: string;
  utmSource: string;
} & AnalyticsConsumerProps;

class HomePage extends React.Component<Props> {
  componentDidMount() {
    const { atlOrigin, utmSource } = this.props;
    this.props.analytics.page('homeScreen', {
      atlOrigin,
      utmSource,
      ...getViewPortDimensions(),
    });
  }

  render() {
    return (
      <div data-test-id="home-page-content">
        <PageTopMargin />
        <ErrorBoundary subject="emptyState">
          <EmptyState />
        </ErrorBoundary>
        <ErrorBoundary subject="products">
          <Products />
        </ErrorBoundary>
        <ErrorBoundary subject="yourWorkTabs">
          <YourWorkTabs />
        </ErrorBoundary>
      </div>
    );
  }
}

export default withAnalytics(HomePage);
